var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"timeline--connector align-center",attrs:{"data-aos":"zoom-in","data-aos-once":"false"}})}
var staticRenderFns = []

export { render, staticRenderFns }